module.exports = __webpack_public_path__ + "static/media/laying_v2.d77ffe4c.jpg";